import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  FileImageOutlined,
  AppstoreOutlined,
  EnvironmentOutlined,
  FileOutlined,
  IdcardOutlined,
  LinkOutlined,
  MailOutlined,
  PictureOutlined,
  QrcodeOutlined,
  TagOutlined,
  InstagramOutlined,
  TwitterOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";
import "./Footer.css";

const FooterLayout = () => {
  const navigate = useNavigate();

  return (
    <footer className="ftr">
      {/* ── Top band ── */}
      <div className="ftr-top">
        <div className="ftr-inner">

          {/* Brand col */}
          <div className="ftr-brand">
            <img src={require("../../assets/logo.png")} alt="Bonoxi" className="ftr-logo" />
            <p className="ftr-tagline">
              Simple, fast tools for PDF conversion and QR code generation — built for everyone.
            </p>
            <div className="ftr-social">
              <a href="#" className="ftr-social-btn" aria-label="Twitter"><TwitterOutlined /></a>
              <a href="#" className="ftr-social-btn" aria-label="LinkedIn"><LinkedinOutlined /></a>
              <a href="#" className="ftr-social-btn" aria-label="Instagram"><InstagramOutlined /></a>
            </div>
          </div>

          {/* PDF Tools col */}
          <div className="ftr-col">
            <div className="ftr-col-title">PDF Tools</div>
            <ul className="ftr-links">
              <li><button onClick={() => navigate("/word2pdf")}><FileWordOutlined /> Word to PDF</button></li>
              <li><button onClick={() => navigate("/excel2pdf")}><FileExcelOutlined /> Excel to PDF</button></li>
              <li><button onClick={() => navigate("/ppt2pdf")}><FilePptOutlined /> PowerPoint to PDF</button></li>
              <li><button onClick={() => navigate("/image2pdf")}><FileImageOutlined /> Image to PDF</button></li>
            </ul>
          </div>

          {/* QR Tools col */}
          <div className="ftr-col">
            <div className="ftr-col-title">QR Tools</div>
            <ul className="ftr-links">
              <li><button onClick={() => navigate("/qr-link")}><LinkOutlined /> Link to QR</button></li>
              <li><button onClick={() => navigate("/qr-text")}><QrcodeOutlined /> Text to QR</button></li>
              <li><button onClick={() => navigate("/qr-location")}><EnvironmentOutlined /> Location QR</button></li>
              <li><button onClick={() => navigate("/qr-brand")}><PictureOutlined /> Brand QR</button></li>
              <li><button onClick={() => navigate("/qr-social")}><AppstoreOutlined /> Social QR</button></li>
              <li><button onClick={() => navigate("/qr-file")}><FileOutlined /> File QR</button></li>
              <li><button onClick={() => navigate("/qr-vcard")}><IdcardOutlined /> vCard QR</button></li>
              <li><button onClick={() => navigate("/qr-product")}><TagOutlined /> Product QR</button></li>
              <li><button onClick={() => navigate("/qr-message")}><MailOutlined /> Message QR</button></li>
            </ul>
          </div>

          {/* Company col */}
          <div className="ftr-col">
            <div className="ftr-col-title">Company</div>
            <ul className="ftr-links">
              <li><Link to="/blogs">Blog</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms & Conditions</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="ftr-bottom">
        <div className="ftr-inner ftr-bottom-inner">
          <span className="ftr-copy">© {new Date().getFullYear()} Bonoxi. All rights reserved.</span>
          <div className="ftr-bottom-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterLayout;
